import React, {useState} from "react";
import { Pagination } from "@components";
import { Input,  Select, Radio } from "@components/form";
import {  FormProvider } from 'react-hook-form';
import { useParams} from "react-router-dom";
import { useLectureInvoice } from "@hooks";
import { useQueryClient } from '@tanstack/react-query';
import {LectureInvoiceModal} from "./LectureInvoiceModal";
import { qk } from "@utils/queryKey";
import LectureTabNav from './LectureTabNav';

const LectureInvoice = () => {
  const { lectureId } = useParams();

  const {
    methods, data,
    onSubmit,
    handlePageChange, handleDelete, handleExcelDownload, resetSearch,
    pageIndex, recordCountPerPage,
  } = useLectureInvoice(lectureId);

  const [formModalOpen, setFormModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const queryClient = useQueryClient();

  const handleAddCompany = (e) => {
    e.preventDefault();
    setEditItem(null);
    setFormModalOpen(true);
  };

  const handleUpdateCompany = (item) => {
    setEditItem(item);
    setFormModalOpen(true);
  };

  const handleModalSuccess = (response) => {
    alert(response.message);
    queryClient.invalidateQueries({ queryKey: qk.invoiceList(lectureId) });
    queryClient.invalidateQueries({ queryKey: qk.invoiceAllList()});
  };


  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="contents-wrap">
        <LectureTabNav lectureId={lectureId} active="invoice" />
          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
              <div className="search-wrap">
                <div className="search-row">
                  <div className="search-item">
                    <label>조회 조건</label>
                    <Select
                      name="searchCnd"
                      options={[
                        { key: "0", name: "아이디" },
                        { key: "1", name: "이름" },
                        { key: "2", name: "회사명" },
                      ]}
                      defaultOption="전체"
                      className="input-select"
                    />
                    <Input
                      name="searchWrd"
                      placeholder="검색어를 입력하세요"
                      className="input-search"
                      style={{ width: "300px" }}
                    />

                    <label style={{marginLeft:"20px"}}>유형</label>
                    <Radio name="sourceType" label="전체" value="" />
                    <Radio name="sourceType" label="개인" value="P" />
                    <Radio name="sourceType" label="단체" value="G" />
                  </div>
                  <div className="search-btn-container">
                    <button type="submit" className="btn-search">조회</button>
                    <button type="button" className="btn-reset" onClick={resetSearch}>초기화</button>
                  </div>
                </div>
              </div>
                <section className="section-wrap">
                  <div className="section-tit-wrap">
                    <h3 className="border-left-primary">
                      &nbsp;계산서 명단
                      <span className="total-txt">
                        {" "} | 총 <span className="red">{data?.totalCount} 건</span> 
                      </span>
                    </h3>
                    <div className="btn-right-box">
                      <ul>
                        <li><button title="엑셀" className="btn-excel"  onClick={handleExcelDownload}>엑셀</button></li>
                        <li><button title="등록" className="btn-add"  onClick={handleAddCompany}>단체등록</button></li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-container">
                    <div className="table-box">
                    <table className="table-list" style={{width:"100%"}}>
                      <colgroup>
                        <col style={{ width: "3%" }} />   {/* No */}

                        <col style={{ width: "10%" }} />  {/* 회사명 */}
                        <col style={{ width: "5%" }} />   {/* 유형 */}
                        <col style={{ width: "5%" }} />   {/* 인원 */}
                        <col style={{ width: "5%" }} />   {/* 공급가액 */}
                        <col style={{ width: "5%" }} />   {/* 부가세 */}
                        <col style={{ width: "5%" }} />   {/* 총액 */}
                        <col style={{ width: "5%" }} />  {/* 담당자 */}
                        <col style={{ width: "7%" }} />  {/* 연락처 */}
                        <col style={{ width: "12%" }} />  {/* 이메일 */}
                        <col style={{ width: "12%" }} />  {/* 회원ID */}
                        <col style={{ width: "10%" }} />  {/* 회원명 */}
                        <col style={{ width: "5%" }} />   {/* 관리 */}
                      </colgroup>
                      <thead>
                        <tr>
                          <th>번호</th>
                          <th>회사명</th>
                          <th>유형</th>
                          <th>인원</th>
                          <th>공급가(원)</th>
                          <th>세액(원)</th>
                          <th>총액(원)</th>
                          <th>담당자</th>
                          <th>연락처</th>
                          <th>이메일</th>
                          <th>회원ID</th>
                          <th>회원명</th>
                          <th>관리 </th>
                        </tr>
                      </thead>
                      <tbody>
                      {data?.resultList && data.resultList.length > 0 ? (
                        data.resultList.map((item, idx) => {
                          const isGroup = item.sourceType === 'G';
                          return (
                            <tr key={item.invoiceId}>
                              <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>



                              <td>{item.companyNm}</td>
                              <td>{isGroup ? '단체' : '개인'}</td>
                              <td>{item.studentCnt.toLocaleString()}</td>
                              <td>₩ {item.supplyAmt.toLocaleString()}</td>
                              <td>₩ {item.vatAmt.toLocaleString()}</td>
                              <td>₩ {item.totalAmt.toLocaleString()}</td>
                              <td>{item.taxMgrNm}</td>
                              <td>{item.taxMgrPhone}</td>
                              <td>{item.taxMgrEmail}</td>
                              <td>{isGroup ? '-' : item.memberId}</td>
                              <td>{isGroup ? '-' : item.memberNm}</td>
                              <td>
                                {isGroup && (
                                  <div className="table-list-btn">
                                    <button
                                      type="button"
                                      className="btn-save"
                                      onClick={() => handleUpdateCompany(item)}
                                    >
                                      수정
                                    </button>
                                    <button
                                      type="button"
                                      className="btn-cancel ml10"
                                      onClick={() => handleDelete(item.invoiceId)}
                                    >
                                      삭제
                                    </button>
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={12} style={{ textAlign: 'center' }}>
                            조회 결과가 없습니다.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    </table>
                    </div>
                  </div>
                    {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                    <Pagination
                        totalPages={Math.ceil(
                          data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                        )}
                        currentPage={pageIndex}
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={10}
                    />
                    )}
                </section>
            </div>
          </div>
        </div>
      </form>
      <LectureInvoiceModal
        isOpen={formModalOpen}
        onClose={() => setFormModalOpen(false)}
        lectureId={lectureId}
        isEdit={!!editItem}   
        defaultData={editItem} 
        onSuccess={handleModalSuccess}
      />
    </FormProvider>
    
  );
};

export {LectureInvoice};
